"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ErrorPage;
var _react = _interopRequireDefault(require("react"));
var _ErrorPageSharedContent = _interopRequireDefault(require("./ErrorPageSharedContent"));
function ErrorPage() {
  return /*#__PURE__*/_react.default.createElement(_ErrorPageSharedContent.default, {
    errorHeadingText: 'apptNotFoundHeader',
    bannerText: 'apptNotFoundBanner'
  });
}
ErrorPage.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ErrorPage"
};